import mitt from 'mitt';
import { useToast } from "vue-toastification";
const toast = useToast();
export const EventBus = mitt();

let hasMessageShown = false;

const EventBusMixin = {
  created() {
    // Listen for success and error events
    EventBus.on('success', this.handleSuccess);
    EventBus.on('error', this.handleError);
  },

  beforeUnmount() {
    // Remove the listeners when the component is destroyed
    EventBus.off('success', this.handleSuccess);
    EventBus.off('error', this.handleError);
  },

  methods: {
    handleSuccess(message) {
      if (!hasMessageShown) {
        // Show success toast
        toast.success(message);

        // Set the flag to prevent multiple displays
        hasMessageShown = true;

        // Reset the flag after 3 seconds
        setTimeout(() => {
          hasMessageShown = false;
        }, 3000); // 3000 milliseconds = 3 seconds
      }
    },

    handleError(message) {
      if (!hasMessageShown) {
        toast.error(message);

        // Set the flag to prevent multiple displays
        hasMessageShown = true;

        // Reset the flag after 3 seconds
        setTimeout(() => {
          hasMessageShown = false;
        }, 3000); // 3000 milliseconds = 3 seconds
      }
    },
  },
};

export default EventBusMixin;
